// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346l4.906 5.397-4.897 5.25a1 1 0 0 0 .375 1.625l7.204 2.701-1.828 9.158a1 1 0 0 0 1.711.875l7.733-8.285 4.796 5.275a1 1 0 1 0 1.48-1.345l-20-21.997Zm6.931 22.423 1.309-6.547a1 1 0 0 0-.625-1.133L7.75 16.589l3.765-4.034 7.598 8.358-5.442 5.837Zm-.088-17.875a1 1 0 0 1-.05-1.414l5.736-6.145a1 1 0 0 1 1.711.875l-1.832 9.172 7.203 2.7a1 1 0 0 1 .375 1.62l-2.787 2.986a1 1 0 0 1-1.463-1.364l1.774-1.894-6.6-2.475a1 1 0 0 1-.625-1.132l1.309-6.548L15 8.828a1 1 0 0 1-1.418.047Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
